// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on (A4U9).
// Account's Profile at /account/profile (A12U24): the avatar opens it; below 840 px the Account sections follow the
// form, from 840 the layout draws them beside the page.
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import { AccountSections } from '../../features/account/AccountSections'
import { ProfileForm } from '../../features/account/ProfileForm'
import { meQuery } from '../../shared/org/me'
import { Part } from '../../shared/shell/StatePart'
import { useWindowClass } from '../../shared/shell/useWindowClass'

export const Route = createFileRoute('/account/profile')({
  staticData: { screenId: 'ProfileScreen', access: 'signed in' },
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(meQuery()),
  component: ProfileScreen,
})

function ProfileScreen() {
  const { t } = useTranslation()
  const windowClass = useWindowClass()
  const beside = windowClass === 'expanded' || windowClass === 'wide'
  return (
    <main data-testid={ids.profile.root} className="flex flex-col gap-(--stack-lg)">
      <PageHeader title={t('account.profile.title')}>
        <p className="text-fg-muted">{t('account.profile.lede')}</p>
      </PageHeader>
      <Part testId={ids.profile.skeleton}>
        <ProfileForm />
      </Part>
      {!beside && <AccountSections className="max-w-md" />}
    </main>
  )
}
